/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import { mutationOptions, useMutation } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  GenerateExportMutationRequest,
  GenerateExportMutationResponse,
} from "../types/GenerateExport.ts"

export const generateExportMutationKey = () =>
  [{ url: "/v1/export/generate" }] as const

export type GenerateExportMutationKey = ReturnType<
  typeof generateExportMutationKey
>

/**
 * @summary Generate export
 * {@link /v1/export/generate}
 */
export async function generateExport(
  data: GenerateExportMutationRequest,
  config: Partial<RequestConfig<GenerateExportMutationRequest>> & {
    client?: typeof fetch
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    GenerateExportMutationResponse,
    ResponseErrorConfig<Error>,
    GenerateExportMutationRequest
  >({
    method: "POST",
    url: `/v1/export/generate`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function generateExportMutationOptions(
  config: Partial<RequestConfig<GenerateExportMutationRequest>> & {
    client?: typeof fetch
  } = {}
) {
  const mutationKey = generateExportMutationKey()
  return mutationOptions<
    ResponseConfig<GenerateExportMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: GenerateExportMutationRequest },
    typeof mutationKey
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return generateExport(data, config)
    },
  })
}

/**
 * @summary Generate export
 * {@link /v1/export/generate}
 */
export function useGenerateExport<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<GenerateExportMutationResponse>,
      ResponseErrorConfig<Error>,
      { data: GenerateExportMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<GenerateExportMutationRequest>> & {
      client?: typeof fetch
    }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? generateExportMutationKey()

  const baseOptions = generateExportMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<GenerateExportMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: GenerateExportMutationRequest },
    TContext
  >

  return useMutation<
    ResponseConfig<GenerateExportMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: GenerateExportMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<GenerateExportMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: GenerateExportMutationRequest },
    TContext
  >
}
